<div class="chip" [style.maxWidth.px]="maxWidth">
  <div class="circle" [style.background]="color || '#D8D3C6'"></div>
  <span class="text">{{ text }}</span>
</div>

<div class="chip mobile" [style.background]="color" [style.maxWidth.px]="maxWidth">
  <span class="text">{{ text }}</span>
</div>
